import React, {useState, useEffect} from 'react';
import { notification } from '../../hocs/notification';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';

import { Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, Badge } from 'reactstrap';
import { FaFilePdf, FaPlus, FaEye, FaClock, FaCheckCircle, FaCertificate, FaChartLine } from 'react-icons/fa';
import { MdAddCircle, MdBusiness, MdVerified } from 'react-icons/md';
import { TbCertificate, TbReportMoney } from 'react-icons/tb';
import AddCompliance from './AddCompliance';
import AddCertificate from './AddCertificate';

const financialData = [
    {
        sl: 1,
        name: "Nutritional Program",
        detail:"An equity certificate representing a 100% undivided beneficial ownership interest in the Trust.",
        figure: <div className="fw-bold text-success">&#8377; 40,000</div>,
    },
    {
        sl: 2,
        name: "Papaya Cultivation Program",
        detail:"the certificate of registration or other documents in lieu thereof establishing that the Goods supplied",
        figure: <div className="fw-bold text-success">&#8377; 1,25,000</div>,
    },
]

const Compliance = () => {

    const [mode, setMode] = useState(1);
    const [loadingCompliance, setLoadingCompliance] = useState(false);
    const [loadingCertificate, setLoadingCertificate] = useState(false);
    const [loadingFinancial, setLoadingFinancial] = useState(false);

    const [complianceData, setComplianceData] = useState('');
    const [certificateData, setCertificateData] = useState('');
    
    const [modalData, setModalData] = useState('');
    const [viewModal, setViewModal] = useState(false);

    useEffect(()=>{
        get_compliance_list();
        get_certificate_list();
    },[])

    const get_compliance_list = () => {
        setLoadingCompliance(true);
        let postData = [{"org_id": sessionStorage.getItem('org_id')}];

        axios({
            method: 'post',
            url: mainurl + 'Master/get_compliance_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                
                let list = response.data.map((row, index) => {
                    let frequency, status, statusBadge;
                    if(row.frequency === "1"){
                        frequency = "Yearly"; 
                    }else if(row.frequency === "2"){
                        frequency = "Half Yearly"; 
                    }else if(row.frequency === "3"){
                        frequency = "Quarterly"; 
                    }else if(row.frequency === "4"){
                        frequency = "Monthly"; 
                    }else if(row.frequency === "5"){
                        frequency = "Weekly"; 
                    }

                    if(row.status === "1"){
                        status = "Pending";
                        statusBadge = <Badge color="warning" className="fw-normal"><FaClock size={12} className="me-1" />Pending</Badge>;
                    }else if(row.status === "2"){
                        status = "Completed";
                        statusBadge = <Badge color="success" className="fw-normal"><FaCheckCircle size={12} className="me-1" />Completed</Badge>;
                    }
                    return(
                        {
                            sl: index + 1,
                            name: <div className="fw-medium">{row.compliance_name}</div>,
                            detail: <div className="text-muted small">{row.compliance_desc}</div>,
                            frequency: <Badge color="info" className="fw-normal">{frequency}</Badge>,
                            status: statusBadge,
                            last_update: <div className="small">{row.last_update.split(" ")[0].split('-').reverse().join('-')}</div>,
                            pdf_link: <Button color="danger" size="sm" className="btn-icon rounded-circle p-2">
                                <FaFilePdf size={14} />
                            </Button>, 
                            action: <div className="d-flex gap-2">
                                <Button color="primary" size="sm" className="btn-icon rounded-circle p-2" onClick={()=>show_return_dtl(row.compliance_type_id)}>
                                    <FaEye size={14} />
                                </Button>
                                <Button color="success" size="sm" className="btn-icon rounded-circle p-2" onClick={add_return_dtl}>
                                    <MdAddCircle size={14} />
                                </Button>
                            </div>
                        }
                    )
                });
                setComplianceData(list);
                setLoadingCompliance(false);
            })
            .catch(error => {
                setLoadingCompliance(false);
            });
    }

    const add_return_dtl = () => {
        "Master/add_compliance_return"
    }
    
    const show_return_dtl = (id) => {
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "compliance_id": 1}];
        axios({
            method: 'post',
            url: mainurl + 'Master/view_compliance_return',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                
                let list = response.data.map((row, index) => {
                    
                    return(
                        {
                            sl: index + 1,
                            return_amt: <div className="fw-bold text-success">&#8377; {row.return_amt}</div>,
                            month: <Badge color="secondary">{row.month}</Badge>,
                            year: <Badge color="primary">{row.year}</Badge>,
                            return_date: <div className="small">{row.return_date.split(" ")[0].split('-').reverse().join('-')}</div>,
                            file: <Button color="danger" size="sm" className="btn-icon rounded-circle p-2">
                                <FaFilePdf size={14} />
                            </Button>
                        }
                    )
                });
                setModalData(list);
                setViewModal(true);
            })
            .catch(error => {
                setLoadingCertificate(false);
            });
    }

    const get_certificate_list = () => {
        setLoadingCertificate(true);
        let postData = [{"org_id": sessionStorage.getItem('org_id')}];    

        axios({
            method: 'post',
            url: mainurl + 'Master/get_certificate_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                
                let list = response.data.map((row, index) => {
                    const isExpiringSoon = new Date(row.expiry_date) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
                    
                    return(
                        {
                            sl: index + 1,
                            name: <div className="fw-medium d-flex align-items-center">
                                <MdVerified className="text-success me-2" size={16} />
                                {row.certificate_name}
                            </div>,
                            cert_no: <Badge color="info" className="fw-normal">{row.certificate_no}</Badge>,
                            detail: <div className="text-muted small">{row.certificate_desc}</div>,
                            issue: <div className="small text-success">{row.issue_date.split(" ")[0].split('-').reverse().join('-')}</div>,
                            expiry: <div className={`small ${isExpiringSoon ? 'text-danger fw-bold' : 'text-muted'}`}>
                                {isExpiringSoon && <FaClock className="me-1" size={12} />}
                                {row.expiry_date.split(" ")[0].split('-').reverse().join('-')}
                            </div>,
                            pdf_link: <Button color="danger" size="sm" className="btn-icon rounded-circle p-2">
                                <FaFilePdf size={14} />
                            </Button>
                        }
                    )
                });
                setCertificateData(list);
                setLoadingCertificate(false);
            })
            .catch(error => {
                setLoadingCertificate(false);
            });
    }

    const tabsData = [
        { 
            mode: 1, 
            label: "Statutory Compliance", 
            icon: FaCheckCircle, 
            color: "primary",
            bgColor: "#07653815"
        },
        { 
            mode: 2, 
            label: "Certificates", 
            icon: TbCertificate, 
            color: "success",
            bgColor: "#07653815"
        },
        { 
            mode: 3, 
            label: "Financials", 
            icon: TbReportMoney, 
            color: "warning",
            bgColor: "#07653815"
        }
    ];

    return(
        <>

            {/* Quick Stats Cards */}
            <Row className="g-4 mb-4">
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Active Compliances</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-primary">
                                        {Array.isArray(complianceData) ? complianceData.length : 0}
                                    </h3>
                                    <small className="text-success">All monitored</small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center"
                                        style={{ 
                                            backgroundColor: '#07653815', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <FaCheckCircle size={28}  className="text-primary" />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Valid Certificates</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-success">
                                        {Array.isArray(certificateData) ? certificateData.length : 0}
                                    </h3>
                                    <small className="text-success">Up to date</small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center"
                                        style={{ 
                                            backgroundColor: '#2E8B5715', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <FaCertificate size={28} className="text-success" />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Financial Records</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-warning">
                                        {financialData.length}
                                    </h3>
                                    <small className="text-success">Current</small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center"
                                        style={{ 
                                            backgroundColor: '#DAA52015', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <FaChartLine size={28}  className="text-warning"  />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Enhanced Tab Navigation */}
            {(mode === 1 || mode === 2 || mode === 3) &&
                <Card className="mb-3 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                    <CardBody className="p-3">
                        <div className="d-flex flex-wrap gap-2">
                            {tabsData.map((tab) => (
                                <Button
                                    key={tab.mode}
                                    className={`tab-button d-flex align-items-center gap-2 px-4 py-2 ${mode === tab.mode ? 'active bg-primary' : ''}`}
                                    style={{
                                        backgroundColor: mode === tab.mode ? tab.color : 'transparent',
                                        color: mode === tab.mode ? 'white' : '#6c757d',
                                        border: mode === tab.mode ? 'none' : '2px solid #e9ecef',
                                        borderRadius: '8px',
                                        fontWeight: '500',
                                        transition: 'all 0.3s ease',
                                        transform: mode === tab.mode ? 'translateY(-1px)' : 'none',
                                        boxShadow: mode === tab.mode ? '0 4px 12px rgba(0,0,0,0.15)' : 'none'
                                    }}
                                    onClick={() => setMode(tab.mode)}
                                    onMouseEnter={(e) => {
                                        if (mode !== tab.mode) {
                                            e.target.style.backgroundColor = tab.bgColor;
                                            e.target.style.color = tab.color;
                                            e.target.style.transform = 'translateY(-1px)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (mode !== tab.mode) {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#6c757d';
                                            e.target.style.transform = 'none';
                                        }
                                    }}
                                >
                                    <tab.icon size={16} />
                                    {tab.label}
                                </Button>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            }

            {/* Statutory Compliance Section */}
            {mode === 1 && 
                <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                    <CardHeader className='d-flex justify-content-between align-items-center py-3' style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '2px solid #e9ecef',
                        borderRadius: '10px 10px 0 0'
                    }}>
                        <div className="d-flex align-items-center gap-2">
                            <FaCheckCircle className="text-success" size={20} />
                            <span className="fw-bold">Statutory Compliance Details</span>
                        </div>
                        <Button 
                            className='d-flex align-items-center gap-2 px-4 py-2' 
                            color='success' 
                            style={{ borderRadius: '8px', fontWeight: '500' }}
                            onClick={() => setMode(4)}
                        >
                            <FaPlus size={14} /> Add New
                        </Button>
                    </CardHeader>
                    <CardBody className="p-0">
                        <DataTable
                            customStyles={{
                                ...custTableStyles,
                                headRow: {
                                    style: {
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        fontWeight: '600'
                                    }
                                },
                                rows: {
                                    style: {
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa',
                                            transform: 'scale(1.001)',
                                            transition: 'all 0.2s ease'
                                        }
                                    }
                                }
                            }}
                            columns={[
                                {
                                    name: 'SL. No.',
                                    selector: row => row.sl,
                                    sortable: false,
                                    width: '80px',
                                    center: true
                                },
                                {
                                    name: 'Name',
                                    selector: row => row.name,
                                    sortable: false,
                                    width: "15%",
                                    wrap: true
                                },
                                {
                                    name: 'Detail',
                                    selector: row => row.detail,
                                    sortable: false,
                                    width: "25%",
                                    wrap: true
                                },
                                {
                                    name: 'Frequency',
                                    selector: row => row.frequency,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'Status',
                                    selector: row => row.status,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'Last Update',
                                    selector: row => row.last_update,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'PDF',
                                    selector: row => row.pdf_link,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'Action',
                                    selector: row => row.action,
                                    sortable: false,
                                    center: true
                                },
                            ]}
                            data={complianceData}
                            highlightOnHover
                            progressPending={loadingCompliance}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </CardBody>
                </Card>
            }

            {mode === 4 &&  
                <AddCompliance back={()=>{setMode(1);get_compliance_list();}} />
            }

            {/* Certificates Section */}
            {mode === 2 && 
                <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                    <CardHeader className='d-flex justify-content-between align-items-center py-3' style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '2px solid #e9ecef',
                        borderRadius: '10px 10px 0 0'
                    }}>
                        <div className="d-flex align-items-center gap-2">
                            <FaCertificate className="text-info" size={20} />
                            <span className="fw-bold">Certificates Details</span>
                        </div>
                        <Button 
                            className='d-flex align-items-center gap-2 px-4 py-2' 
                            color='info' 
                            style={{ borderRadius: '8px', fontWeight: '500' }}
                            onClick={() => setMode(5)}
                        >
                            <FaPlus size={14} /> Add New
                        </Button>
                    </CardHeader>
                    <CardBody className="p-0">
                        <DataTable
                            customStyles={{
                                ...custTableStyles,
                                headRow: {
                                    style: {
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        fontWeight: '600'
                                    }
                                },
                                rows: {
                                    style: {
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa',
                                            transform: 'scale(1.001)',
                                            transition: 'all 0.2s ease'
                                        }
                                    }
                                }
                            }}
                            columns={[
                                {
                                    name: 'SL. No.',
                                    selector: row => row.sl,
                                    sortable: false,
                                    width: '80px',
                                    center: true
                                },
                                {
                                    name: 'Name',
                                    selector: row => row.name,
                                    sortable: false,
                                    width: "20%",
                                    wrap: true
                                },
                                {
                                    name: 'Certificate No',
                                    selector: row => row.cert_no,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'Detail',
                                    selector: row => row.detail,
                                    sortable: false,
                                    width: "25%",
                                    wrap: true
                                },
                                {
                                    name: 'Issue Date',
                                    selector: row => row.issue,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'Expiry Date',
                                    selector: row => row.expiry,
                                    sortable: false,
                                    center: true
                                },
                                {
                                    name: 'PDF',
                                    selector: row => row.pdf_link,
                                    sortable: false,
                                    center: true
                                },
                            ]}
                            data={certificateData}
                            highlightOnHover
                            progressPending={loadingCertificate}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </CardBody>
                </Card>
            }

            {mode === 5 &&  
                <AddCertificate back={()=>{setMode(2);get_certificate_list();}} />
            }

            {/* Financials Section */}
            {mode === 3 && 
                <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                    <CardHeader className='d-flex justify-content-between align-items-center py-3' style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '2px solid #e9ecef',
                        borderRadius: '10px 10px 0 0'
                    }}>
                        <div className="d-flex align-items-center gap-2">
                            <FaChartLine className="text-warning" size={20} />
                            <span className="fw-bold">Financials Details</span>
                        </div>
                        <Button 
                            className='d-flex align-items-center gap-2 px-4 py-2' 
                            color='warning' 
                            style={{ borderRadius: '8px', fontWeight: '500' }}
                        >
                            <FaPlus size={14} /> Add New
                        </Button>
                    </CardHeader>
                    <CardBody className="p-0">
                        <DataTable
                            customStyles={{
                                ...custTableStyles,
                                headRow: {
                                    style: {
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        fontWeight: '600'
                                    }
                                },
                                rows: {
                                    style: {
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa',
                                            transform: 'scale(1.001)',
                                            transition: 'all 0.2s ease'
                                        }
                                    }
                                }
                            }}
                            columns={[
                                {
                                    name: 'SL. No.',
                                    selector: row => row.sl,
                                    sortable: false,
                                    width: '80px',
                                    center: true
                                },
                                {
                                    name: 'Name',
                                    selector: row => row.name,
                                    sortable: false,
                                    width: "20%",
                                    wrap: true
                                },
                                {
                                    name: 'Detail',
                                    selector: row => row.detail,
                                    sortable: false,
                                    width: "35%",
                                    wrap: true
                                },
                                {
                                    name: 'Figure',
                                    selector: row => row.figure,
                                    sortable: false,
                                    center: true
                                },
                            ]}
                            data={financialData}
                            highlightOnHover
                            progressPending={loadingFinancial}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </CardBody>
                </Card>
            }

            {/* Enhanced Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="custom-modal"
            >
                <ModalHeader 
                    toggle={() => setViewModal(!viewModal)}
                    className="border-bottom-0 pb-1"
                    style={{ backgroundColor: '#f8f9fa' }}
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaEye className="text-primary" size={20} />
                        <span className="fw-bold">Return Details</span>
                    </div>
                </ModalHeader>
                <ModalBody className="p-0">
                    <DataTable
                        customStyles={{
                            ...custTableStyles,
                            headRow: {
                                style: {
                                    backgroundColor: '#f8f9fa',
                                    fontWeight: '600'
                                }
                            }
                        }}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.sl,
                                sortable: true,
                                width: '80px',
                                center: true
                            },
                            {
                                name: 'Amount',
                                selector: row => row.return_amt,
                                sortable: false,
                                center: true
                            },
                            {
                                name: 'Month',
                                selector: row => row.month,
                                sortable: false,
                                center: true
                            },
                            {
                                name: 'Year',
                                selector: row => row.year,
                                sortable: false,
                                center: true
                            },
                            {
                                name: 'Date',
                                selector: row => row.return_date,
                                sortable: false,
                                center: true
                            },
                            {
                                name: 'File',
                                selector: row => row.file,
                                sortable: false,
                                center: true
                            },
                        ]}
                        data={modalData}
                        highlightOnHover
                        pagination
                        progressPending={!modalData}
                    />
                </ModalBody>
            </Modal>

            <style jsx>{`
                .stat-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }

                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                }

                .stat-title {
                    font-size: 0.85rem;
                    letter-spacing: 0.5px;
                }

                .stat-value {
                    font-size: 2rem;
                    line-height: 1.2;
                }

                .btn-icon {
                    transition: all 0.2s ease;
                }

                .btn-icon:hover {
                    transform: scale(1.1);
                }

                .tab-button {
                    transition: all 0.3s ease;
                    border: none !important;
                }

                .tab-button:hover {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                }

                .custom-modal .modal-content {
                    border-radius: 10px;
                    border: none;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                }

                .dashboard-header {
                    animation: slideIn 0.5s ease-out;
                }

                .stat-card {
                    animation: fadeInUp 0.5s ease-out;
                }

                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .dashboard-header h4 {
                        font-size: 1.25rem;
                    }
                    
                    .stat-value {
                        font-size: 1.5rem;
                    }
                    
                    .stat-icon {
                        width: 50px !important;
                        height: 50px !important;
                    }

                    .tab-button {
                        font-size: 0.875rem;
                        padding: 8px 16px !important;
                    }
                }

                /* Custom DataTable Enhancements */
                .rdt_Table {
                    border-radius: 0 0 10px 10px;
                }

                .rdt_TableHead {
                    background-color: #f8f9fa !important;
                }

                .rdt_TableRow:hover {
                    background-color: #f8f9fa !important;
                    cursor: pointer;
                }

                /* Badge Enhancements */
                .badge {
                    font-size: 0.75rem;
                    padding: 0.375rem 0.75rem;
                    border-radius: 6px;
                }

                /* Button Enhancements */
                .btn {
                    transition: all 0.2s ease;
                }

                .btn:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }

                /* Loading Animation */
                .loading-skeleton {
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: loading 1.5s infinite;
                    border-radius: 4px;
                }

                @keyframes loading {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }

                /* Card Shadow Enhancement */
                .shadow-sm {
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
                }

                /* Responsive Table */
                @media (max-width: 768px) {
                    .rdt_Table {
                        font-size: 0.875rem;
                    }
                }
            `}</style>
        </>
    )
}

export default Compliance;